import { render } from "./ConfirmationDialog.vue?vue&type=template&id=cb979bae"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script